module.exports = __webpack_public_path__ + "img/de-round.2e5a2072.svg";